import type { ISbStoryData } from '@storyblok/js'
import { useStoryblokState } from '@storyblok/react'
import type { ProductOfferPage } from '@percent/cause-dashboard/storyblok/types/storyblok-components'
import { ProductOfferDetailCMSPageContent } from './ProductOfferDetailCMSPageContent'

export type ProductOfferDetailPageStoryBridgeProps = {
  initialStory: ISbStoryData<ProductOfferPage>
}

/** Subscribes to Storyblok Visual Editor bridge for live updates in preview. */
export function ProductOfferDetailCMSPageStoryBridge({
  initialStory
}: Readonly<ProductOfferDetailPageStoryBridgeProps>) {
  const bridged = useStoryblokState(initialStory)
  const story = bridged ?? initialStory

  return <ProductOfferDetailCMSPageContent story={story} />
}
